module.exports = __webpack_public_path__ + "img/FGr_Schwere_Bergung_A.719f3c79.svg";